import {
  Box,
  FilledInput,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  makeStyles,
  MenuItem,
  Select,
  Button,
  Icon,
  TextField,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context";
import { get } from "../../utils/api-services";
import dayjs from "dayjs";
import DateRange from "../../common/date-range";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    paddingBottom: 20,
  },
  requiredValue: {
    fontWeight: "600",
    color: "rgba(255,0,0,1)",
  },
  buttonsContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    marginBottom: 20,
  },
  button: {
    marginLeft: 15,
  },
}));

export default function SearchForm({ makeRequestParentFunction }) {
  const { showToast, showLoader } = useContext(AuthContext);
  const classes = useStyles();

  const [state, setState] = useState({
    fincas: [],
    products: [],
    perimeter: {
      finca: "",
      product: "",
      startDate: dayjs().subtract(2, "day").toDate(),
      endDate: new Date(),
    },
    filter: {
      dateRange: `${dayjs()
        .subtract(7, "day")
        .format("MM/DD/YYYY")} - ${dayjs().format("MM/DD/YYYY")}`,
    },
    rangeModalOpen: false,
  });

  useEffect(() => {
    makeRequest();
  }, []);

  const makeRequest = async () => {
    showLoader(true);
    try {
      const [fincas, products] = await Promise.all([
        get("/fincas/farms"),
        get("/fincas/products"),
      ]);

      setState((prev) => ({
        ...prev,
        fincas: fincas.data,
        products: products.data,
      }));
    } catch (error) {
      showToast("Error fetching data:", "error");
    } finally {
      showLoader(false);
    }
  };

  const handleParameterChange = ({ target }) => {
    setState((prev) => ({
      ...prev,
      perimeter: { ...prev.perimeter, [target.name]: target.value },
    }));
  };

  const clearForm = () => {
    setState((prev) => ({
      ...prev,
      perimeter: {
        finca: "",
        product: "",
        startDate: new Date(),
        endDate: new Date(),
      },
    }));
  };

  const searchForm = () => {
    makeRequestParentFunction({
      farm_id: state.perimeter.finca || "",
      product_id: state.perimeter.product || "",
      startDate: state.perimeter.startDate
        ? dayjs(state.perimeter.startDate).format("YYYY-MM-DD")
        : "",
      endDate: state.perimeter.endDate
        ? dayjs(state.perimeter.endDate).format("YYYY-MM-DD")
        : "",
    }, true);
  };

  const toggleRangeModal = () => {
    setState((prev) => ({
      ...prev,
      rangeModalOpen: !prev.rangeModalOpen,
    }));
  };

  const handleDateChange = (item) => {
    const key = Object.keys(item)[0];

    if (!key || !item[key]) {
      console.error("Invalid date range selection:", item);
      return;
    }

    const { startDate, endDate } = item[key];

    setState((prev) => ({
      ...prev,
      perimeter: { ...prev.perimeter, startDate, endDate },
      filter: {
        ...prev.filter,
        dateRange: `${dayjs(startDate).format("MM/DD/YYYY")} - ${dayjs(
          endDate
        ).format("MM/DD/YYYY")}`,
      },
    }));
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={4} lg={4}>
          <FormGroup onClick={toggleRangeModal}>
            <FormLabel>{"Date Range"}</FormLabel>
            <FormControl variant="filled" component={Box} width="100%">
              <FilledInput
                readOnly
                type="text"
                value={state.filter.dateRange}
                endAdornment={<Icon>{"calendar_month"}</Icon>}
              />
            </FormControl>
          </FormGroup>
        </Grid>

        <Grid item xs={12} sm={4} lg={4}>
          <FormGroup>
            <FormLabel>
              {"Farms"} <span className={classes.requiredValue}>*</span>
            </FormLabel>
            <Autocomplete
              options={state.fincas}
              getOptionLabel={(option) => option.name || ""}
              value={
                state.fincas.find(
                  (option) => option.idfinca_farm === state.perimeter.finca
                ) || null
              }
              onChange={(event, newValue) =>
                handleParameterChange({
                  target: {
                    name: "finca",
                    value: newValue ? newValue.idfinca_farm : "",
                  },
                })
              }
              renderInput={(params) => (
                <TextField {...params}/>
              )}
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} sm={4} lg={4}>
          <FormGroup>
            <FormLabel>
              {"Product"} <span className={classes.requiredValue}>*</span>
            </FormLabel>
            <Autocomplete
              options={state.products}
              getOptionLabel={(option) => option.name || ""}
              value={
                state.products.find(
                  (option) =>
                    option.idfinca_product === state.perimeter.product
                ) || null
              }
              onChange={(event, newValue) =>
                handleParameterChange({
                  target: {
                    name: "product",
                    value: newValue ? newValue.idfinca_product : "",
                  },
                })
              }
              renderInput={(params) => (
                <TextField {...params}/>
              )}
            />
          </FormGroup>
        </Grid>
      </Grid>

      <DateRange
        open={state.rangeModalOpen}
        range={[state.perimeter]}
        onClose={toggleRangeModal}
        onChange={handleDateChange}
      />

      <div className={classes.buttonsContainer}>
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={clearForm}
        >
          {"Cancel"}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={searchForm}
        >
          {"Search"}
        </Button>
      </div>
    </div>
  );
}
